export default __webpack_public_path__ + "static/media/dollor.53bd9000.svg";